import { DJVerificationApi } from '@bpm-web-app/supreme-api-sdk';
import { supremeConfig } from '../config';

export class DJVerification {
    static client = new DJVerificationApi(supremeConfig);

    static getVerificationQuestions = () => DJVerification.client.getVerificationQuestions();
}
